export default __webpack_public_path__ + "static/media/interiorCap.536fd648.PNG";